(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["et-video-description"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  var button=event.target.closest('.et-video-facade__play');
  if(!button)return;
  var root=button.closest('.et-video-facade');
  var template=root.querySelector('template');
  if(!template)return;
  var content=template.content.cloneNode(true);
  var frame=content.querySelector('iframe');
  if(!frame)return;
  frame.removeAttribute('loading');
  button.replaceWith(content);
  frame.focus();
  template.remove();
});
  } catch(e) { console.error(e); }
})();

})();
